export const Light = {
  palette: {
    mode: "light",
    type: "light",
    action: {
      selected: "#1cc8d4",
    },
    primary: {
      main: "#1cc8d4",
      dark: "#1b8187",
      contrastText: "#000000",
    },
    secondary: {
      main: "#006bf5",
    },
    text: {
      disabled: "#696969",
      hint: "rgba(220,0,0,0.38)",
      secondary: "rgba(15,15,105,0.94)",
      primary: "rgba(0,44,135,0.87)",
    },
    success: {
      main: "#9afff3",
    },
  },
  typography: {
    body2: {
      fontSize: "0.8rem",
    },
  },
};
